import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

const LocationIndicator = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className="flex justify-center my-4"
    >
      <div id="location-indicator" className="relative inline-block">
        <div className="glass-button">
          <p className="main-title text-gray-600 flex items-center justify-center gap-1">
            Disponível em
            <span className="font-medium text-blue-dark">Campo Grande - MS</span>
            <MapPin className="h-4 w-4 text-blue-main ml-1" />
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LocationIndicator;